export default __webpack_public_path__ + "static/media/legalFrame.3ce2be56.jpg";